// Which linked files a tracking control may offer.
//
// THE BUG THIS EXISTS TO END (owner, 2026-09-20): "does the source button
// in construction tracking respect the links/models unselected in project
// card config?" It did not. The tracking board took the model-documents
// response whole, so its picker offered - and its "N of M linked files"
// counted - files the project card has switched off, whose geometry is
// deliberately NOT DRAWN: every streaming viewer drops their rows at tile
// ingest. Picking one gave rows and counts for a file nobody can see.
// The list and the stream disagreed about what the model is.
//
// `switchedOff` AND NOT THE `hidden` FLAG, which is the part worth
// keeping: the server combines BOTH project-card controls into
// switchedOff - the "Model files" gear AND the placement dialog's
// visible:false (back/utils/hiddenDocuments.combineHidden). On the
// project that prompted this, SpaceX BA03, modelSourceFilter is NULL and
// all thirteen files are hidden by the PLACEMENT dialog. Filtering on
// `hidden` would have read correctly, passed review, and changed nothing
// at all on the project it was written for.
//
// A pure function so it can be tested against the REAL response shape
// rather than through a rendered page - the seam that produced three
// defects in one day was always a shape nobody drove end to end.

/** The documents a tracking control may show, given the API response. */
export function visibleDocuments(response) {
  const documents = (response && response.documents) || [];
  const off = new Set(
    (((response && response.switchedOff) || {}).documents || [])
      .map((d) => String(d && d.id)),
  );
  if (!off.size) return documents;
  return documents.filter((d) => !off.has(String(d && d.id)));
}

/**
 * "N of M linked files", counted from the SAME visible set on both sides.
 * A pick SAVED before a file was switched off is still in `pickedIds`, so
 * counting it against the filtered list would read "3 of 2". Returns null
 * when nothing is picked and the caller should say "all linked files".
 */
export function filterLabel(documents, pickedIds) {
  if (!pickedIds || !pickedIds.length) return null;
  const picked = new Set(pickedIds.map(String));
  const n = (documents || []).filter((d) => picked.has(String(d && d.id))).length;
  return `${n} of ${(documents || []).length} linked files`;
}
